// src/App.jsx (Version corrigée)
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import FixedEditorLayout from './pages/Editor';
import MediaManager from './pages/MediaManager';
import Scheduler from './pages/Scheduler';
import Settings from './pages/Settings';
import './App.css';

function App() {
  return (
    <div className="App h-screen overflow-hidden">
      <AppProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/editor" element={<FixedEditorLayout />} />
              <Route path="/media" element={<MediaManager />} />
              <Route path="/scheduler" element={<Scheduler />} />
              <Route path="/settings" element={<Settings />} />
            </Routes>
          </Layout>
        </Router>
      </AppProvider>
    </div>
  );
}

export default App;